export default "__VITE_ASSET__puoqQ0TZ__"